import { Form, Input, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { RecoilState, useRecoilState } from "recoil";
import {
  apiCompaniesList,
  apiEditLinkOrgService,
} from "../../../../../api/api";
import { CompanyServiceMatchType } from "../../../../../types";
import { companyList } from "../../state";

export const ModalEditLink = ({
  modalState,
  updateDataSource,
}: {
  modalState: RecoilState<CompanyServiceMatchType | undefined>;
  updateDataSource: React.Dispatch<
    React.SetStateAction<CompanyServiceMatchType[]>
  >;
}) => {
  const [form] = Form.useForm<any>();
  const [editedLink, setEditedLink] = useRecoilState(modalState);
  const [loading, setLoading] = useState<boolean>(false);
  const [companies, setCompanies] = useRecoilState(companyList);

  const editLinkOrgService = async (values: { [index: string]: string }) => {
    setLoading(true);
    const { serviceId, serviceName, inn } = values;
    if (!editedLink) {
      setLoading(false);
      return;
    }
    const newServiceId =
      serviceId === editedLink.serviceId ? undefined : serviceId;
    try {
      const resp = await apiEditLinkOrgService(
        editedLink.serviceId,
        serviceName,
        inn,
        newServiceId
      );
      if (inn !== editedLink.inn && editedLink.inn === resp.result.inn) {
        message.warning(
          "У данной организации имеются заведённые дела, изменение организации невозможно"
        );
        if (serviceName === editedLink.serviceName) {
          return;
        }
      }
      if (newServiceId && resp.result.serviceId !== newServiceId) {
        message.warning(
          "У данной услуги имеются заведённые дела, изменение идентификатора невозможно"
        );
        if (inn === editedLink.inn && serviceName === editedLink.serviceName)
          return;
      }
      updateDataSource((oldArray) => {
        const rowToEdit = oldArray.findIndex(
          (row) =>
            row.inn === editedLink?.inn &&
            row.serviceId === editedLink.serviceId
        );
        const newDataSource = [...oldArray];
        newDataSource[rowToEdit] = {
          ...newDataSource[rowToEdit],
          serviceName: resp.result.serviceName,
          serviceId: resp.result.serviceId,
          inn: resp.result.inn,
          companyName:
            companies?.find((el) => el.inn === resp.result.inn)?.companyName ||
            "",
        };
        return newDataSource;
      });
      message.success("Запись отредактирована");
    } finally {
      setLoading(false);
    }
    setEditedLink(undefined);
  };

  const getCompanies = async () => {
    const resp = await apiCompaniesList();
    setCompanies(resp.result);
  };

  useEffect(() => {
    if (editedLink) {
      form.setFields([
        {
          name: "serviceName",
          value: editedLink.serviceName,
        },
        {
          name: "serviceId",
          value: editedLink.serviceId,
        },
        {
          name: "inn",
          value: editedLink.inn,
        },
      ]);
      if (!companies) {
        getCompanies();
      }
    }
  }, [editedLink]);

  useEffect(
    () => () => {
      if (companies) setCompanies(undefined);
    },
    []
  );

  return (
    <Modal
      title="Редактировать"
      visible={!!editedLink}
      onOk={() => form.submit()}
      onCancel={() => setEditedLink(undefined)}
      confirmLoading={loading}
      afterClose={() => {
        form.resetFields();
      }}
      maskClosable={false}
      width="500px"
      cancelText="Отменить"
      okText="Сохранить"
      forceRender
    >
      <Form
        form={form}
        onFinish={editLinkOrgService}
        labelCol={{
          span: 7,
        }}
      >
        <Form.Item label="Организация" name="inn">
          <Select loading={!companies}>
            {companies?.map((el) => (
              <Select.Option value={el.inn}>{el.companyName}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Идентификатор услуги" name="serviceId">
          <Input />
        </Form.Item>
        <Form.Item label="Название услуги" name="serviceName">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};
